import get from 'lodash/get';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    loading: false,
    errors: [],
    activeStep: 'main',
    appLoaded: false,
    reviewLoading: false
};

/*******************************************************************************
 * Non-async action types
 */
export const LOADING_START = 'loading/start';
export const LOADING_END = 'loading/end';
export const REVIEW_LOADING = 'review/loading';
export const SET_APP_LOADED = 'recognition/appLoaded';
export const SET_ERRORS = 'recognition/setErrors';
export const SET_ACTIVE_STEP = 'recognition/setActiveStep';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case LOADING_END: {
            return {
                ...state,
                loading: false
            };
        }
        case REVIEW_LOADING: {
            return {
                ...state,
                reviewLoading: action.reviewLoading
            };
        }
        case SET_APP_LOADED: {
            return {
                ...state,
                appLoaded: action.appLoaded
            };
        }
        case SET_ERRORS: {
            return {
                ...state,
                errors: action.errors
            };
        }
        case SET_ACTIVE_STEP: {
            return {
                ...state,
                activeStep: action.activeStep
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function startLoading() {
    return {
        type: LOADING_START
    };
}

export function endLoading() {
    return {
        type: LOADING_END
    };
}

export function reviewLoading( loadingState ) {
    return {
        type: REVIEW_LOADING,
        reviewLoading: loadingState
    };
}

export function setAppLoaded( appLoaded ) {
    return {
        type: SET_APP_LOADED,
        appLoaded: appLoaded
    };
}

export function setErrors( errors ) {
    return {
        type: SET_ERRORS,
        errors: errors
    };
}

export function clearErrors() {
    return {
        type: SET_ERRORS,
        errors: []
    };
}

export function setActiveStep( activeStep ) {
    return {
        type: SET_ACTIVE_STEP,
        activeStep: activeStep
    };
}

// Selectors
export const getActiveStep = state => get( state, 'app.activeStep', 'main' );
export const getErrors = state => get( state, 'app.errors', [] );
export const getReviewLoading = state => get( state, 'app.reviewLoading', false );